import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import countryApi from '../../../../../../middleware/api/ProjectManagement/Projects/ProjectView/Invoices/AddCountry/addCountryApi'
import {
  LoadingState,
  ValidationError,
} from '../../../../../../types/commonTypes'
import {
  CountryListState,
  GetCountries,
} from '../../../../../../types/ProjectManagement/Project/ProjectView/Invoices/CountryList/countryDetailstype'
import { ApiLoadingState } from '../../../../../../middleware/api/apiList'
import { RootState } from '../../../../../../stateStore'

const addCountry = createAsyncThunk(
  'addCountry/Country',
  async (name: string, thunkApi) => {
    try {
      return await countryApi.addCountry(name)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)
const getCountries = createAsyncThunk(
  'getCountries/Country',
  async (_, thunkApi) => {
    try {
      return await countryApi.getcountries()
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)
const deleteCountry = createAsyncThunk(
  '/deleteCountry/Country',
  async (id: number, thunkApi) => {
    try {
      return await countryApi.deleteCountry(id)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

export const initialcountrystate: CountryListState = {
  getCountryList: [],
  isLoading: ApiLoadingState.idle,
}
const addCountrySlice = createSlice({
  name: 'addCountry',
  initialState: initialcountrystate,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCountries.fulfilled, (state, action) => {
        state.isLoading = ApiLoadingState.succeeded
        state.getCountryList = action.payload
      })
      .addCase(getCountries.pending, (state) => {
        state.isLoading = ApiLoadingState.loading
      })
  },
})
const addCountryThunk = {
  addCountry,
  getCountries,
  deleteCountry,
}

const isLoading = (state: RootState): LoadingState =>
  state.countryList.isLoading
const addCoountry = (state: RootState): GetCountries[] =>
  state.countryList.getCountryList

const addCountrySelectors = {
  isLoading,
  addCoountry,
}

export const countryListService = {
  ...addCountryThunk,
  actions: addCountrySlice.actions,
  selectors: addCountrySelectors,
}

export default addCountrySlice.reducer
